// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zohT","col":"styles_col__1TGcM"};